import fonts from './fonts';
export { fontSize } from './size';
export { default as fonts } from './fonts';

export default fonts;
